import React from 'react';

interface SectionProps {
    backgroundImage: string;
    title: string;
    buttonText: string;
    styles: { [key: string]: string };
    className?: string;
    onButtonClick?: () => void;
}

const Section: React.FC<SectionProps> = ({ backgroundImage, title, buttonText, styles, className, onButtonClick }) => {
    return (
        <div className={`${styles.section}${className ? ' ' + className : ''}`} style={{ backgroundImage: `url(${backgroundImage})` }}>
            <h2 className={styles.sectionTitle}>{title}</h2>
            <button className={styles.sectionButton} onClick={onButtonClick}>{buttonText}</button>
        </div>
    );
};

export default Section; 